import type { LineDataElement } from './ChartBase-types';

export const accessors = {
	xAccessor: (d: LineDataElement): Date => d.x,
	yAccessor: (d: LineDataElement): number | undefined => d.y,
	xDescriptionAccessor: (d: LineDataElement): string | undefined => d.xDescription,
	yDescriptionAccessor: (d: LineDataElement): string | undefined => d.yDescription,
};
